import React from 'react'
import Modal from 'react-bootstrap/Modal'
import EarQList from './EarQList'
import Button from 'react-bootstrap/Button'


function EarQListModal(props) {

    const onSelect = (earQ) => {
        props.onSelect(earQ)
    }

  return (
        <Modal dialogClassName="modal-80w" show={props.show} onHide={props.onClose} animation={false} scrollable={true}>
            <Modal.Header closeButton>
                <Modal.Title><h4>The Ear-Q</h4></Modal.Title>
            </Modal.Header>
            <Modal.Body className="mx-4" >
                <EarQList onSelect={onSelect} unUpdateOrDelete={props.onUpdateOrDelete}  updateDeleteCount={props.updateDeleteCount}/>
            </Modal.Body>
            <Modal.Footer className='justify-content-between'>
                <div >
                    <Button className='mx-2' variant="secondary" onClick={props.onClose}>
                        Close
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
  )
}

export default EarQListModal
